module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded",
    staticStyle: {
      "text-align": "left"
    }
  }, [(!_vm.hidePanel) ? _c('edit-pane', {
    ref: "ep",
    attrs: {
      "prefix": "Equipment:",
      "title": _vm.equip.name,
      "editable": _vm.isTelco() ? false : _vm.isManager('project|maintenance|finance|admin'),
      "is-edit": !_vm.disabled
    },
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel,
      "edit": _vm.onEdit,
      "add": _vm.onSave
    }
  }) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [(_vm.canAccess('project|maintenance|finance|admin') && _vm.isTowerCo() && (_vm.isDesktop || _vm.isTablet)) ? _c('el-col', {
    attrs: {
      "lg": 4
    }
  }, [_c('h5', [_vm._v("Features")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('project|maintenance|finance|admin') && _vm.isTowerCo()) ? _c('el-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "Maint.",
      "disabled": _vm.disabled,
      "no-form": ""
    },
    model: {
      value: (_vm.equip.isMaint),
      callback: function($$v) {
        _vm.$set(_vm.equip, "isMaint", $$v)
      },
      expression: "equip.isMaint"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canAccess('project|maintenance|finance|admin') && _vm.isTowerCo()) ? _c('el-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "Dim.",
      "disabled": _vm.disabled,
      "no-form": ""
    },
    model: {
      value: (_vm.equip.hasDimensions),
      callback: function($$v) {
        _vm.$set(_vm.equip, "hasDimensions", $$v)
      },
      expression: "equip.hasDimensions"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canAccess('project|maintenance|finance|admin') && _vm.isTowerCo()) ? _c('el-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "On Tower",
      "disabled": _vm.disabled,
      "no-form": ""
    },
    model: {
      value: (_vm.equip.onTower),
      callback: function($$v) {
        _vm.$set(_vm.equip, "onTower", $$v)
      },
      expression: "equip.onTower"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canAccess('project|maintenance|finance|admin') && _vm.isTowerCo()) ? _c('el-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "Uses Power",
      "disabled": _vm.disabled,
      "no-form": ""
    },
    model: {
      value: (_vm.equip.usesPower),
      callback: function($$v) {
        _vm.$set(_vm.equip, "usesPower", $$v)
      },
      expression: "equip.usesPower"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canAccess('project|maintenance|finance|admin') && _vm.isTowerCo()) ? _c('el-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "Prov. Pwr.",
      "disabled": _vm.disabled,
      "no-form": ""
    },
    model: {
      value: (_vm.equip.providesPower),
      callback: function($$v) {
        _vm.$set(_vm.equip, "providesPower", $$v)
      },
      expression: "equip.providesPower"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canAccess('project|maintenance|finance|admin') && _vm.isTowerCo()) ? _c('el-col', {
    attrs: {
      "xs": 12,
      "sm": 12,
      "md": 6,
      "lg": 3
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "Billable",
      "disabled": _vm.disabled,
      "no-form": ""
    },
    model: {
      value: (_vm.equip.isBillable),
      callback: function($$v) {
        _vm.$set(_vm.equip, "isBillable", $$v)
      },
      expression: "equip.isBillable"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [(_vm.canAccess('project|maintenance|finance|admin')) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.tabs),
      callback: function($$v) {
        _vm.tabs = $$v
      },
      expression: "tabs"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "equip-general"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-asterisk"
  }), (_vm.isDesktop) ? _c('span', [_vm._v(" Details ")]) : _vm._e()]), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.equip,
      "label-position": "left",
      "label-width": "120px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": _vm.adding ? 24 : 18,
      "lg": _vm.adding ? 24 : 18
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('select-equip-category', {
    attrs: {
      "disabled": (_vm.disabled || !_vm.canAccess('project|maintenance|finance'))
    },
    model: {
      value: (_vm.catType),
      callback: function($$v) {
        _vm.catType = $$v
      },
      expression: "catType"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(_vm.adding) ? _c('el-alert', {
    attrs: {
      "show-icon": "",
      "type": "error",
      "title": "Note!",
      "description": "You can add equipment/assets for all sharers, backhaul, tower providers and contractors here. If you need to add equipment for new sharer, create that sharer first."
    }
  }) : _vm._e(), _vm._v(" "), (this.isTowerCo()) ? _c('select-organisation', {
    attrs: {
      "type": "Telco,Contractor",
      "label": "Owner",
      "sharer-limits": _vm.limits,
      "disabled": _vm.disabled || !_vm.canAccess('project|maintenance|finance')
    },
    model: {
      value: (_vm.equip.owner_id),
      callback: function($$v) {
        _vm.$set(_vm.equip, "owner_id", $$v)
      },
      expression: "equip.owner_id"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Name",
      "placeholder": "Asset name",
      "disabled": _vm.disabled || !_vm.canAccess('project|maintenance|finance'),
      "prefix": _vm.equip.name ? 'fa fa-cog' : null,
      "is-prefix-icon": true
    },
    model: {
      value: (_vm.equip.name),
      callback: function($$v) {
        _vm.$set(_vm.equip, "name", $$v)
      },
      expression: "equip.name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('text-input', {
    attrs: {
      "label": "Serial No.",
      "placeholder": "Serial No.",
      "disabled": _vm.disabled || !_vm.canAccess('project|maintenance|finance'),
      "prefix": _vm.equip.serialNo ? 'fa fa-barcode' : null,
      "is-prefix-icon": true
    },
    model: {
      value: (_vm.equip.serialNo),
      callback: function($$v) {
        _vm.$set(_vm.equip, "serialNo", $$v)
      },
      expression: "equip.serialNo"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('number-input', {
    attrs: {
      "label": "Quantity",
      "placeholder": "Quantity",
      "disabled": _vm.disabled || !_vm.canAccess('project|maintenance|finance')
    },
    model: {
      value: (_vm.equip.qty),
      callback: function($$v) {
        _vm.$set(_vm.equip, "qty", $$v)
      },
      expression: "equip.qty"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('number-input', {
    attrs: {
      "label": "Set #",
      "placeholder": "Set #",
      "disabled": _vm.disabled || !_vm.canAccess('project|maintenance|finance')
    },
    model: {
      value: (_vm.equip.setNo),
      callback: function($$v) {
        _vm.$set(_vm.equip, "setNo", $$v)
      },
      expression: "equip.setNo"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Installed Date",
      "placeholder": "Installed Date",
      "disabled": _vm.disabled || !_vm.canAccess('project|maintenance|finance')
    },
    model: {
      value: (_vm.equip.installedOn),
      callback: function($$v) {
        _vm.$set(_vm.equip, "installedOn", $$v)
      },
      expression: "equip.installedOn"
    }
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.adding && _vm.isTowerCo()) ? _c('el-col', {
    attrs: {
      "span": 6,
      "align": "center"
    }
  }, [_c('qr-code', {
    attrs: {
      "text": _vm.qrCode,
      "color": _vm.equip.organisation.colourCode,
      "label": _vm.equip.organisation.shortName,
      "file-name": _vm.fileName,
      "bw-background": true
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.equip.isMaint && !this.adding && _vm.canAccess('project|maintenance|finance')) ? _c('el-tab-pane', {
    attrs: {
      "name": "equip-maint"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-wrench"
  }), (_vm.isDesktop) ? _c('span', [_vm._v(" Maintenance")]) : _vm._e()]), _vm._v(" "), _c('h4', [_vm._v("Maintenance")]), _vm._v(" "), _c('equip-maint', {
    attrs: {
      "is-edit": !_vm.disabled,
      "row-data": _vm.equip,
      "site-id": _vm.siteId,
      "asset-id": _vm.equip.id
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canAccess('project|maintenance|finance') && _vm.isTowerCo()) ? _c('el-tab-pane', {
    attrs: {
      "name": "equip-remarks"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-comment-alt"
  }), (_vm.isDesktop) ? _c('span', [_vm._v(" Remarks")]) : _vm._e()]), _vm._v(" "), _c('el-form', [_c('html-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.equip.reamrks),
      callback: function($$v) {
        _vm.$set(_vm.equip, "reamrks", $$v)
      },
      expression: "equip.reamrks"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!this.adding && _vm.canAccess('project|maintenance') && _vm.isTowerCo()) ? _c('el-tab-pane', {
    attrs: {
      "name": "equip-atach"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  }), (_vm.isDesktop) ? _c('span', [_vm._v(" Attachments")]) : _vm._e()]), _vm._v(" "), _c('files-panel', {
    attrs: {
      "type": "site",
      "id": _vm.equip.site_id,
      "process": "equip",
      "process-id": _vm.equip.id
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.equip.hasDimensions && _vm.canAccess('project|maintenance|finance')) ? _c('el-tab-pane', {
    attrs: {
      "name": "equip-dim"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-pencil-ruler"
  }), (_vm.isDesktop) ? _c('span', [_vm._v(" Dimensions")]) : _vm._e()]), _vm._v(" "), _c('h4', [_vm._v("Physical Dimensions")]), _vm._v(" "), _c('dimensions', {
    attrs: {
      "row-data": _vm.equip,
      "is-edit": !_vm.disabled
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.equip.onTower && _vm.canAccess('project|maintenance|finance')) ? _c('el-tab-pane', {
    attrs: {
      "name": "equip-on-tower"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-broadcast-tower"
  }), (_vm.isDesktop) ? _c('span', [_vm._v(" Pos.")]) : _vm._e()]), _vm._v(" "), _c('h4', [_vm._v("On Tower Location")]), _vm._v(" "), _c('on-tower', {
    attrs: {
      "is-edit": !_vm.disabled,
      "row-data": _vm.equip
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.equip.usesPower && _vm.canAccess('project|maintenance|finance')) ? _c('el-tab-pane', {
    attrs: {
      "name": "equip-pwr-req"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-battery-half"
  }), (_vm.isDesktop) ? _c('span', [_vm._v(" Pwr. Req")]) : _vm._e()]), _vm._v(" "), _c('h4', [_vm._v("Power Consumption")]), _vm._v(" "), _c('power', {
    attrs: {
      "is-edit": !_vm.disabled,
      "row-data": _vm.equip
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.equip.providesPower && _vm.canAccess('project|maintenance')) ? _c('el-tab-pane', {
    attrs: {
      "name": "equip-pwr-gen"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-plug"
  }), (_vm.isDesktop) ? _c('span', [_vm._v(" Pwr Gen")]) : _vm._e()]), _vm._v(" "), _c('h4', [_vm._v("Power Generation")]), _vm._v(" "), _c('power-gen', {
    attrs: {
      "is-edit": !_vm.disabled,
      "row-data": _vm.equip
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.equip.isBillable && _vm.canAccess('finance') && _vm.isTowerCo()) ? _c('el-tab-pane', {
    attrs: {
      "name": "equip-billable"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-file-invoice-dollar"
  }), (_vm.isDesktop) ? _c('span', [_vm._v(" Billing")]) : _vm._e()]), _vm._v(" "), _c('h4', [_vm._v("Billing Details")]), _vm._v(" "), _c('billable', {
    attrs: {
      "is-edit": !_vm.disabled,
      "row-data": _vm.equip
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.equip.updated_at) ? _c('div', [_c('hr'), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("Last update: "), _c('b', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.equip.updated_at)))]), _vm._v(" (" + _vm._s(_vm.formatDateTime(_vm.equip.updated_at)) + ")"), (_vm.equip.updated_by) ? _c('span', [_vm._v(" by " + _vm._s(_vm.equip.updated_by))]) : _vm._e()])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8789384e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/EquipDetails.vue
// module id = 1586
// module chunks = 0